import { supabase } from '@/integrations/supabase/client';

export interface AdminContact {
  email: string;
  full_name: string | null;
}

export async function fetchWorkspaceAdminContacts(orgId: string): Promise<AdminContact[]> {
  const { data: roles, error: rolesError } = await supabase
    .from('core_roles')
    .select('id')
    .eq('org_id', orgId)
    .in('code', ['owner', 'admin']);

  if (rolesError) throw rolesError;
  if (!roles || roles.length === 0) return [];

  const roleIds = roles.map((role) => role.id);

  const { data: memberRoles, error: memberRolesError } = await supabase
    .from('core_member_roles')
    .select('member_id')
    .in('role_id', roleIds);

  if (memberRolesError) throw memberRolesError;
  if (!memberRoles || memberRoles.length === 0) return [];

  const memberIds = [...new Set(memberRoles.map((memberRole) => memberRole.member_id))];

  const { data: members, error: membersError } = await supabase
    .from('core_organization_members')
    .select('id, user_id')
    .eq('org_id', orgId)
    .eq('status', 'active')
    .in('id', memberIds);

  if (membersError) throw membersError;
  if (!members || members.length === 0) return [];

  const userIds = [...new Set(members.map((member) => member.user_id))];

  const { data: profiles, error: profilesError } = await supabase
    .from('core_profiles')
    .select('id, email, full_name')
    .in('id', userIds);

  if (profilesError) throw profilesError;

  const profileMap = new Map(
    (profiles || [])
      .filter((profile) => Boolean(profile.email))
      .map((profile) => [profile.id, profile])
  );

  return members.flatMap((member) => {
    const profile = profileMap.get(member.user_id);

    if (!profile) return [];

    return [
      {
        email: profile.email,
        full_name: profile.full_name,
      },
    ];
  });
}